module.exports = __webpack_public_path__ + "img/s2s-logo.c472e9cf.png";